module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('only-container', [_c('h3', [_vm._v(" 迷路了么？这里什么也不存在 ")]), _vm._v(" "), _c('p', [_vm._v(" 回到 "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Splash'
      }
    }
  }, [_vm._v("最开始的地方吧")])], 1), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://as.bitinn.net/upload/cite0l5z200oiz35nbv8t5xox.1200.jpg",
      "alt": ""
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76aac80f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/NotFound.vue
// module id = 159
// module chunks = 1